module.exports = __webpack_public_path__ + "media/images/kc_grey-f013b85e5d5841447276ab118018b3d0.png";